import type { AuthProviderConfig } from '@podus/auth';
import { getAuthUrl } from '@podus/utils';

export const authConfig: AuthProviderConfig = {
    authUrl: import.meta.env.VITE_AUTH_URL ?? getAuthUrl(),
};
